import axios from 'axios'

export default {
  // CRUD
  getEnrollmentTemplates ({ commit }, queryString='') {
    commit('getEnrollmentTemplatesRequest')
    let url = `/api/enrollment-template/?limit=0`

    if (queryString) {
      url = `${url}&${queryString}`
    }

    return axios
      .get(url)
      .then((response) => {
        commit('getEnrollmentTemplatesSuccess', response.data)
        return response
      })
      .catch((error) => {
        commit('getEnrollmentTemplatesFailure', error)
        throw error
      })
  },
  createEnrollmentTemplate ({ commit }, enrollmentTemplate) {
    commit('addEnrollmentTemplateRequest')
    let url = `/api/enrollment-template/`
    return axios
      .post(url, enrollmentTemplate)
      .then((response) => {
        commit('addEnrollmentTemplateSuccess', response.data)
        return response.data
      })
      .catch((error) => {
        commit('addEnrollmentTemplateFailure', error.response.data)
        throw error.response.data
      })
  },
  updateEnrollmentTemplate ({ commit }, enrollmentTemplate) {
    commit('updateEnrollmentTemplateRequest')
    let url = `/api/enrollment-template/${enrollmentTemplate.id}/`
    return axios
      .patch(url, enrollmentTemplate)
      .then((response) => {
        commit('updateEnrollmentTemplateSuccess', response.data)
        return response.data
      })
      .catch((error) => {
        commit('updateEnrollmentTemplateFailure', error.response.data)
        throw error.response.data
      })
  },
  deleteEnrollmentTemplate ({ commit }, enrollmentTemplate) {
    commit('deleteEnrollmentTemplateRequest')
    let url = `/api/enrollment-template/${enrollmentTemplate.id}/`
    return axios
      .delete(url, enrollmentTemplate)
      .then((response) => {
        commit('deleteEnrollmentTemplateSuccess', response.data)
        return response.data
      })
      .catch((error) => {
        commit('deleteEnrollmentTemplateFailure', error.response.data)
        throw error.response.data
      })
  },

  // Custom Endpoints
  getTemplate ({ commit }, queryString) {
    commit('deleteEnrollmentTemplateRequest')
    let url = `/api/enrollment-template/get-template/?${queryString}`

    return axios
      .get(url)
      .then((response) => {
        commit('deleteEnrollmentTemplateSuccess', response.data)
        return response.data
      })
      .catch((error) => {
        commit('deleteEnrollmentTemplateFailure', error.response.data)
        throw error.response.data
      })
  }
}
